import './NotesWindow.scss';
import Component from './NotesWindow.js';

export { NotesIcon } from './NotesWindow.js';
export default Component;
